var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0723 16.345C31.0723 15.2686 30.9757 14.2337 30.7963 13.2401H16.5V19.1118H24.6693C24.3174 21.0092 23.248 22.6169 21.6403 23.6933V27.5019H26.546C29.4163 24.8593 31.0723 20.9679 31.0723 16.345Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 31.1795C20.5984 31.1795 24.0345 29.8203 26.546 27.502L21.6403 23.6933C20.281 24.6041 18.5423 25.1422 16.5 25.1422C12.5464 25.1422 9.20002 22.472 8.00636 18.8842H2.93503V22.817C5.43274 27.778 10.5662 31.1795 16.5 31.1795Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00637 18.8842C7.70278 17.9734 7.53029 17.0005 7.53029 16.0001C7.53029 14.9996 7.70278 14.0267 8.00637 13.116V9.18311H2.93504C1.90698 11.2323 1.3205 13.5507 1.3205 16.0001C1.3205 18.4495 1.90698 20.7678 2.93504 22.817L8.00637 18.8842Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.85785C18.7286 6.85785 20.7295 7.62373 22.3027 9.12788L26.6564 4.77412C24.0276 2.32471 20.5915 0.820557 16.5 0.820557C10.5662 0.820557 5.43274 4.22214 2.93503 9.18307L8.00636 13.1159C9.20002 9.52806 12.5464 6.85785 16.5 6.85785Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.018916abf5cf0d8ef4f25da52f6fcead.svg";
export { ForwardRef as ReactComponent };